// components/ErrorPage.tsx
import React from 'react';
import { ErrorHeader } from './ErrorHeader.js';
import { ErrorAlert } from './ErrorAlert.js';
import { ErrorButtons } from './ErrorButtons.js';
import './styles/ErrorPage.css';

const ERROR_TYPES = {
  404: {
    title: 'Page Not Found',
    description: "The page youre looking for doesn't exist or has been moved.",
  },
  500: {
    title: 'Internal Server Error',
    description: 'An unexpected error occurred. Please try again later.',
  },
  403: {
    title: 'Access Denied',
    description: "You don't have permission to access this resource.",
  },
};

export const ErrorPage = ({ statusCode }) => {
  const error = ERROR_TYPES[statusCode];

  return (
    <div className="error-page-container">
      <div className="error-content">
        <ErrorHeader
          Icon={error.icon}
          title={error.title}
          description={error.description}
        />
        <ErrorAlert statusCode={statusCode} description={error.description} />
        <ErrorButtons />
      </div>
    </div>
  );
};
